import React, { useState } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { parsePhoneNumberFromString } from 'libphonenumber-js'

export default function PhoneInput({ className, onBlur, onChange, ...props }) {
  const [value, setValue] = useState('')
  const country = 'DE'

  const onChangeHandler = e => {
    const { value: newValue } = e.target
    const phoneNumber = parsePhoneNumberFromString(newValue, country)

    if (phoneNumber && phoneNumber.isValid()) {
      e.target.setCustomValidity('')
    } else {
      e.target.setCustomValidity('Ungültige Rufnummer')
    }

    setValue(newValue)
    onChange && onChange(e)
  }

  const onBlurHandler = e => {
    const phoneNumber = parsePhoneNumberFromString(value, country)
    if (phoneNumber && phoneNumber.isValid()) {
      const newValue = phoneNumber
        .format('INTERNATIONAL')
        .replace(/^(\+\d+) (\d+) ?/, '$1$2/')
        .replace(/ /g, '')
      setValue(newValue)
    }

    onBlur && onBlur(e)
  }

  return (
    <input
      {...props}
      className={clsx('form-control', className)}
      value={value}
      pattern="^\+\d\d\d+/\d+$"
      onChange={onChangeHandler}
      onBlur={onBlurHandler}
    />
  )
}

PhoneInput.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func
}
